import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import ProductDetail from "../pages/product-detail/page";
import BuyPage from "../pages/buy/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Policies from "../pages/policies/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/product/flower-printed-set",
    element: <ProductDetail />,
  },
  {
    path: "/buy/flower-printed-set",
    element: <BuyPage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/policies",
    element: <Policies />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;